<script setup lang="ts">
definePageMeta({ layout: "search" });

const route = useRoute();

const firstSlug = computed(() => route.params.first?.toString() || "");
const secondSlug = computed(() => route.params.second?.toString() || "");
</script>

<template>
  <WorkersSearchPage :first-slug="firstSlug" :second-slug="secondSlug" />
</template>
